import s from './LeaderboardBanner.module.sass';

import { FC, MouseEvent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import copyToClipboard from 'copy-text-to-clipboard';

import { useTranslator } from '$hooks';
import { goTo } from '$navigation/helper';
import { LEADERBOARD } from '$shared/constants/pages';
import { TELEGRAM_BOT_USERNAME } from '$shared/constants';
import { leaderboardActions, selectLeaderboard } from '$store/leaderboard';
import { LeaderboardType } from '$store/leaderboard/interface';
import { toastActions } from '$store/toast';
import { classNames } from '$utils';

const BANNERS: Partial<
  Record<LeaderboardType, { className: string; title: string; description: string }>
> = {
  gifts_revenue: {
    className: s.halloween,
    title: 'leaderboard_banner_halloween_title',
    description: 'leaderboard_banner_halloween_description',
  },
};

export const LeaderboardBanner: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { type, startAt, endAt, myRank } = useSelector(selectLeaderboard);

  useEffect(() => {
    dispatch(leaderboardActions.load({ main: true }));
  }, [dispatch]);

  const banner = type && BANNERS[type];
  const now = Date.now() / 1000;

  if (!banner || myRank !== -1 || !startAt || now < startAt || now >= endAt) {
    return null;
  }

  const handleOpen = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    goTo(LEADERBOARD);
  };

  const handleCopyLink = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const url = window.isWebApp
      ? `https://t.me/${TELEGRAM_BOT_USERNAME}/app?startapp=leaderboard`
      : `https://${location.host}/leaderboard`;

    copyToClipboard(url);
    dispatch(toastActions.setToastSuccess(t('link_copied')));
  };

  return (
    <div className={classNames(s.card, banner.className)}>
      <div className={s.content}>
        <h3 className={s.title}>{t(banner.title)}</h3>
        <p className={s.description}>{t(banner.description)}</p>
      </div>

      <div className={s.navigation}>
        <button className={s.button} onClick={handleOpen}>
          <span className={s.button_text}>{t('leaderboard_banner_open')}</span>
        </button>
        <button className={s.icon_button} onClick={handleCopyLink}>
          <span className={s.share_icon} />
        </button>
      </div>

      <div className={s.image} />
    </div>
  );
};
